// @core/api/endpoints/task/update_task_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskCategoryResponse,
  UpdateTaskCategoryRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update task category
 * Updates a task category (name, code, defaults, parent).
 */
export async function UpdateTaskCategory(
  category_id: string,
  data: UpdateTaskCategoryRequest,
  options?: RequestOptions
): Promise<TaskCategoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-categories/:category_id`;
  requestPath = requestPath.replace(':category_id', encodeURIComponent(category_id));
  const requestOptions = options;
  return client.put<TaskCategoryResponse>(requestPath, data, requestOptions);
}
